import React, { useContext } from "react";

import { DataContext } from "../../../../../../../providers/GasCheckoutDataProvider";
import NewInput from "../../../../../../shared/forms/NewInput";

const DeliveryAddress = () => {
    const dataContext = useContext(DataContext);

    const { billingAddressData } = dataContext.data;
    const {
        setBillingAddressData,
        addFormError,
        clearFormError,
        hasFormErrorAt,
    } = dataContext.actions;

    const handleChange = (event) => {
        setBillingAddressData({
            ...billingAddressData,
            ...{ [event.target.name]: event.target.value },
        });
    };

    return (
        <React.Fragment>
            <NewInput
                value={billingAddressData.billingstreet}
                onChange={handleChange}
                name="billingstreet"
                placeholder="Straße und Hausnummer"
                validation={"street"}
                forceError={hasFormErrorAt("billingstreet")}
                onError={() => addFormError("billingstreet")}
                onErrorSolved={() => clearFormError("billingstreet")}
                withField
            />

            <NewInput
                placeholder="Plz"
                name="billingzipcode"
                onChange={handleChange}
                value={billingAddressData.billingzipcode}
                validation={"zipcode"}
                fullWidth
                forceError={hasFormErrorAt("billingzipcode")}
                onError={() => addFormError("billingzipcode")}
                onErrorSolved={() => clearFormError("billingzipcode")}
                withField
            />

            <NewInput
                placeholder="Ort"
                name="billingcity"
                onChange={handleChange}
                value={billingAddressData.billingcity}
                validation={"city"}
                fullWidth
                forceError={hasFormErrorAt("billingcity")}
                onError={() => addFormError("billingcity")}
                onErrorSolved={() => clearFormError("billingcity")}
                withField
            />
        </React.Fragment>
    );
};

export default DeliveryAddress;
